import React from 'react';

import { DisabledField, Tag } from './styles';

interface ComingSoonTagProps {
  label?: string;
  variant?: 'default' | 'suggested';
}

const ComingSoonTag: React.FC<ComingSoonTagProps> = ({
  label = 'Em breve',
  variant = 'default',
}) => {
  return <Tag variant={variant}>{label}</Tag>;
};

export { ComingSoonTag, DisabledField };
